module.exports = __webpack_public_path__ + "img/icon_e11.d953494b.png";